// extracted by mini-css-extract-plugin
export default {"container":"NewsContainer_container__Xe7az"};